import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getPaketLabByUnit(unitId: string) {
  const response = await http
    .getData(`/paket-order-lab?unit_id=` + unitId)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

export default {
  getPaketLabByUnit
};
